import React from "react";

import BasePadding from "@cayuse/shared-react.components.base-padding";

const LabelledComponent = ({ label, children }) =>
	(
		<BasePadding>
			<div style={{ display: "flex", flexDirection: "column" }}>
				<div><label>{label}</label></div>
				<div>{children}</div>
			</div>
		</BasePadding>
	);

export default LabelledComponent;
